<template>
    <div class="fancafe_recommend" id="fancafe_recommend" v-if="starArticleList.length > 0">
        <div class="inner_recommend" id="recommend">
            <div class="group_panel">
                <div class="recommend_title fandom">
                    <span class="txt_state">FROM. STAR</span>
                    <strong class="tit_recommend">공식팬카페 <em>스타가 남긴 글</em></strong>
                </div>
                <div class="wrap_btn">
                    <button class="btn_g btn_prev"
                            :class="{btn_disabled : this.curPage === 0}"
                            :disabled="this.curPage === 0"
                            id="recommendPrev"
                            @click="slidePrev"
                            ref="prevButton"><span class="ico_cafetop">이전 보기</span> </button>
                    <button class="btn_g btn_next"
                            :class="{btn_disabled : this.curPage === this.maxPage}"
                            :disabled="this.curPage === this.maxPage"
                            id="recommendNext"
                            @click="slideNext"
                            ref="nextButton"><span class="ico_cafetop">다음 보기</span></button>
                </div>
            </div>
            <div class="wrap_list">
                <ul class="track_list" id="recommendList" ref="listEl">
                    <star-article-item v-for="(starArticle, index) in starArticleList" v-bind="starArticle" :key="'star-article-' + index"></star-article-item>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import StarArticleItem from "./StarArticleItem.vue";
export default {
    components: {
      StarArticleItem  
    },
    data() {
        return {
            starArticleList: [],
            
            curPage: 0,
            
            readyToMove: true,
            moveSize: -912,
            duration: 500
        }
    },
    computed: {
        maxPage() {
            let ret = Math.ceil(this.starArticleList.length / 3);
            if(ret === 0) return ret;
            return ret - 1;
        }
    },
    methods: {
        getStarArticle() {
            const url = "/_c21_/api/fancafe/star/article";
            $.ajax({ url }).then(function (res) {
                this.starArticleList = res.starArticles;
            }.bind(this));
        },
        slidePrev() {
            if(!this.readyToMove || this.curPage === 0) return;
            this.readyToMove = false;
            
            this.curPage--;
            const p = this.curPage * this.moveSize;
            $("#recommendList").animate({"left": p}, this.duration, () => {
                this.readyToMove = true;
            });
        },
        slideNext() {
            if(!this.readyToMove || this.curPage === this.maxPage) return;
            this.readyToMove = false;

            this.curPage++;
            const p = this.curPage * this.moveSize;
            $("#recommendList").animate({ "left": p }, this.duration, () => {
                this.readyToMove = true;
            });
        }
    },
    created() {
        this.getStarArticle();
    }
}
</script>
